export const styles = theme => ({

	root: {
		width: 40,
		height: 20,
		border: '1px solid grey',
	},
    
});